import { ReactNode } from "react";

import { LeadV2Status } from "../../api/generated";
import { LeadStatusDisplay } from "../../LeadStatus";
import { TableMobileHeader } from "../../Table";
import { Typo } from "../../Typo";
import { formatEpochToLocaleDate } from "../../utils/date";
import { ColumnLabels } from "../types";
import { TLead } from "./Columns";

type MobileCardParams = {
  columnLabels?: ColumnLabels;
  canViewPII?: boolean;
  language?: string;
  onHover?: (status: LeadV2Status, isMobile: boolean) => void;
};

type LeadsTableMobileRowProps = {
  label: string;
  value: string | number | ReactNode;
};

const LeadsTableMobileRow = ({ label, value }: LeadsTableMobileRowProps) => (
  <div className="flex items-center justify-between">
    <div className="flex-1">
      <Typo
        element="p"
        type="captionXS"
        classes="leading-6"
        textColor="text-text-secondary"
      >
        {label}
      </Typo>
    </div>
    <div className="flex-1 text-end">
      <Typo element="p" type="labelXS" textColor="text-text-primary">
        {value}
      </Typo>
    </div>
  </div>
);

export const MobileCardBody =
  ({ columnLabels, canViewPII, language, onHover }: MobileCardParams) =>
  (row: TLead) => {
    const clientId = canViewPII
      ? undefined
      : {
          label: columnLabels?.clientIdColumnLabel ?? "",
          value: row.clientId,
        };
    return (
      <div className="flex flex-col gap-1">
        <div>
          <TableMobileHeader
            name={row.name}
            email={row.email}
            clientId={clientId}
          />
          <LeadsTableMobileRow
            label={columnLabels?.statusColumnLabel ?? ""}
            value={
              <div className="flex items-center justify-end text-left">
                <LeadStatusDisplay
                  id={row.clientId}
                  status={row.status}
                  displayValue={row.tStatus}
                  onHover={(status: LeadV2Status, isMobile: boolean) => {
                    if (status !== LeadV2Status.Unknown && onHover) {
                      onHover(status, isMobile);
                    }
                  }}
                  isMobile
                />
              </div>
            }
          />
        </div>
        <LeadsTableMobileRow
          label={columnLabels?.countryColumnLabel ?? ""}
          value={row.tCountry}
        />
        <LeadsTableMobileRow
          label={columnLabels?.createdColumnLabel ?? ""}
          value={
            row.tDate && language
              ? formatEpochToLocaleDate(row.tDate, language)
              : ""
          }
        />
      </div>
    );
  };
